import * as _ from "lodash";
import * as AddOrUpdateElement from "../actions/AddOrUpdateElement";
import * as ImportExport from "../actions/ImportExportActions";
import { TestElementId } from "../actions/SidePanelActions";
import * as UpdateParameter from "../actions/UpdateParameter";
import * as ValidateProcess from "../actions/ValidateProcess";
import * as AnalyzeVariableScope from "../actions/VariableScopeAnalyzer";
import { IAction } from "../model/IAction";
import { ValidationState } from "../model/ValidationData";

export function validation(state: ValidationState = { elementIdsToValidate: [], validationDictionary: {}, variableScopeDictionary: {} }, action: IAction): ValidationState {
    switch (action.type) {
        case UpdateParameter.UPDATE_PARAMETER:
            const updateParameterAction = action as UpdateParameter.UpdateParameterAction;
            const parameterElementId = updateParameterAction.elementId + "." + updateParameterAction.key;
            let updatedElementIdsToValidate = _.union(state.elementIdsToValidate, [parameterElementId]);
            updatedElementIdsToValidate = removePossibleTestElement(updatedElementIdsToValidate);
            return Object.assign({}, state, {elementIdsToValidate: updatedElementIdsToValidate});

        case ValidateProcess.VALIDATE_PROCESS:
            const validateProcessAction = action as ValidateProcess.ValidateProcessAction;
            return Object.assign({}, state, { validationDictionary: validateProcessAction.validationDictionary });

        case AddOrUpdateElement.BATCH_UPDATE_ELEMENTS: {
            const batchAction = action as AddOrUpdateElement.BatchUpdateAction;
            let elementIdsToValidate = _.clone(state.elementIdsToValidate)
                .filter((x) => batchAction.batch.deleted.find((r) => x.startsWith(r)) == null);
            elementIdsToValidate = removePossibleTestElement(elementIdsToValidate);
            return Object.assign({}, state, { elementIdsToValidate: elementIdsToValidate });
        }

        case ValidateProcess.ADD_ELEMENTS_TO_VALIDATION: {
            const addElementsAction = action as ValidateProcess.AddElementsToValidationAction;
            let elementIdsToValidate = _.clone(state.elementIdsToValidate);
            elementIdsToValidate = _.union(elementIdsToValidate, addElementsAction.elementIds, ["process"]); // "process" contains process wide validation
            elementIdsToValidate = removePossibleTestElement(elementIdsToValidate);
            return Object.assign({}, state, { elementIdsToValidate: elementIdsToValidate });
        }
        case AnalyzeVariableScope.UPDATE_VARIABLE_SCOPES:
            const scopeAnalyzeAction = action as AnalyzeVariableScope.AnalyzeVariableScopeAction;
            return Object.assign({}, state, { variableScopeDictionary: scopeAnalyzeAction.scopeDictionary });

        case ImportExport.CLEAR_ELEMENT_STATE:
            return { elementIdsToValidate: [], validationDictionary: {}, variableScopeDictionary: {} };
        default:
            return state;
    }
}

function removePossibleTestElement(elementIdsToValidate: string[]) {
    const testElementIndex = elementIdsToValidate.indexOf(TestElementId);
    if (testElementIndex !== -1) {
        elementIdsToValidate.splice(testElementIndex, 1);
    }
    return elementIdsToValidate;
}
